module.exports = __webpack_public_path__ + "static/media/interest_list.4caebcc8.svg";